<template>
    <v-container>
        <v-layout>
            <v-flex md12 v-if="enFecha">
                <v-card flat v-if="creditosSuficientes">
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Solicitud de Servicio Social</h3>
                        </div>
                    </v-card-title>
                    <v-card-text v-if="!solicitud.capturado">
                        <v-form v-model="valid" v-if="!cargandoDatos">
                            <span class="title">Datos Personales</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Nombre Completo</strong></div>
                                            <p v-html="alumno.nombreCompleto"></p>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="subheading mb-3"><strong>Genero</strong></div>
                                        <p>{{generos[solicitud.genero]}}</p>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="subheading mb-3"><strong>Teléfono</strong></div>
                                        <p>{{solicitud.telefono}}</p>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <div class="subheading mb-3"><strong>Domicilio</strong></div>
                                        <p>{{solicitud.domicilioAlumno}}</p>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span class="title">Escolaridad</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>No. de Control</strong></div>
                                        <p v-html="alumno.noDeControl"></p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Carrera</strong></div>
                                        <p v-html="alumno.carrera"></p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Periodo</strong></div>
                                        <p>{{solicitud.periodo}}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Semestre</strong></div>
                                        <p v-html="alumno.semestre">--</p>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span class="title">Datos del Programa</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.dependencia"
                                                label="Dependencia Oficial"
                                                autocomplete="nope"
                                                :counter="100"
                                                :rules="[v => !!v || 'Es necesario el nombre de la dependencia']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.domicilioDependencia"
                                                label="Dirección de la dependencia"
                                                autocomplete="nope"
                                                :counter="100"
                                                :rules="[v => !!v || 'Es necesario el domicilio']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.ciudad"
                                                label="Ciudad"
                                                autocomplete="nope"
                                                :rules="[v => !!v || 'Es necesaria la ciudad']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.estado"
                                                label="Estado"
                                                autocomplete="nope"
                                                :rules="[v => !!v || 'Es necesario el estado']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.titular"
                                                label="Titular"
                                                autocomplete="nope"
                                                :rules="[v => !!v || 'Es necesario el nombre del titular']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.puesto"
                                                label="Puesto"
                                                autocomplete="nope"
                                                :counter="100"
                                                :rules="[v => !!v || 'Es necesario el puesto']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.programa"
                                                label="Nombre del Programa"
                                                autocomplete="nope"
                                                :counter="250"
                                                :rules="[v => !!v || 'Es necesario el nombre del programa']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="solicitud.responsable"
                                                label="Responsable del programa"
                                                autocomplete="nope"
                                                :counter="100"
                                                :rules="[v => !!v || 'Es necesario el responsable del programa']"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-select
                                                :items="modalidades"
                                                v-model="solicitud.modalidad"
                                                label="Modalidad"
                                                item-value="id"
                                                single-line
                                                :rules="[v => !!v || 'Es necesario seleccionar una modalidad']"
                                                required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-dialog
                                                ref="dialog1"
                                                v-model="modalInicio"
                                                :return-value.sync="solicitud.fechaInicio"
                                                persistent
                                                lazy
                                                full-width
                                                width="290px"
                                        >
                                            <v-text-field
                                                    slot="activator"
                                                    v-model="solicitud.fechaInicio"
                                                    label="Fecha de Inicio"
                                                    prepend-icon="event"
                                                    readonly
                                            ></v-text-field>
                                            <v-date-picker v-model="solicitud.fechaInicio" scrollable locale="es-mx">
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="modalInicio = false">Cancelar</v-btn>
                                                <v-btn flat color="primary" @click="$refs.dialog1.save(solicitud.fechaInicio)">Aceptar</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-dialog
                                                ref="dialog2"
                                                v-model="modalTermino"
                                                :return-value.sync="solicitud.fechaTermino"
                                                persistent
                                                lazy
                                                full-width
                                                width="290px"
                                        >
                                            <v-text-field
                                                    slot="activator"
                                                    v-model="solicitud.fechaTermino"
                                                    label="Fecha de Termino"
                                                    prepend-icon="event"
                                                    readonly
                                            ></v-text-field>
                                            <v-date-picker v-model="solicitud.fechaTermino" scrollable locale="es-mx">
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="modalTermino = false">Cancelar</v-btn>
                                                <v-btn flat color="primary" @click="$refs.dialog2.save(solicitud.fechaTermino)">Aceptar</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-textarea
                                                v-model="solicitud.actividades"
                                                label="Actividades"
                                                multi-line
                                                autocomplete="nope"
                                                :rules="[v => !!v || 'Es necesario proporcionar las actividades a realizar']"
                                                required
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span class="title">Tipo de Programa</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md12>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Programas</strong></div>
                                            <v-radio-group
                                              v-model="solicitud.tipoPrograma"
                                              :rules="[v => !!v || 'Es necesario indicar el tipo de programa']"
                                              required
                                            >
                                                <v-radio color="primary" label="Educación para Adultos" :value="1"></v-radio>
                                                <v-radio color="primary" label="Desarrollo de Comunidad" :value="2"></v-radio>
                                                <v-radio color="primary" label="Actividades Deportivas" :value="3"></v-radio>
                                                <v-radio color="primary" label="Actividades Culturales" :value="4"></v-radio>
                                                <v-radio color="primary" label="PRONASOL" :value="5"></v-radio>
                                                <v-radio color="primary" label="Otros" :value="6"></v-radio>
                                            </v-radio-group>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span class="title">Departamento</span>
                            <span class="subheading">Si presentas tu servicio social dentro del Instituto, selecciona el departamento en el que te encontraras.</span>
                            <v-container fluid grid-list-md>
                              <v-layout row wrap>
                                <v-flex xs12 md12>
                                  <v-card transparent flat>
                                    <v-select
                                      v-model="solicitud.departamento"
                                      :items="departamentos"
                                      label="Selecciona un Departamento"
                                      item-text="descripcion"
                                      item-value="clave"
                                      :rules="[v => !!v || 'Es necesario seleccionar un departamento']"
                                      required
                                    ></v-select>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-container>
                        </v-form>
                        <v-progress-linear :indeterminate="true" v-else="cargandoDatos"></v-progress-linear>
                    </v-card-text>
                    <v-card-text v-if="solicitud.capturado">
                        <p>Tu solicitud de Servicio Social se encuentra en proceso de revisión.</p>
                    </v-card-text>
                    <v-divider class="mt-5"></v-divider>
                    <v-card-actions v-if="!solicitud.capturado">
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat
                                @click="guardar"
                                :loading="guardarLoading"
                                :disabled="guardarLoading || !valid"
                        >Guardar</v-btn>
                    </v-card-actions>
                </v-card>
                <v-card v-else>
                    <v-card-title>
                        <div>
                            <h3 class="headline mb-0">Solicitud de Servicio Social</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                      Aún no cumples con el 70% de créditos aprobados. <br><br>
                      Sí deseas más información acerca de como poder realizar tu Servicio Social puedes acudir
                      al Departamento de Gestión Tecnológica y Vinculación, o enviar un correo a
                      <a href="mailto:caronila.ha@tuxtla.tecnm.mx">carolina.ha@tuxtla.tecnm.mx</a>.
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex md12 v-else>
              <v-card>
                <v-card-title>
                  <div>
                    <h3 class="headline mb-0">Solicitud de Servicio Social</h3>
                  </div>
                </v-card-title>
                <v-card-text>
                  El periodo para realizar la Solicitud de Servicio Social no se encuentra activo.
                </v-card-text>
              </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import * as moment from 'moment'

  export default {
    name: 'SolicitudPage',
    data: () => ({
      valid: false,
      cargandoDatos: false,
      modalInicio: false,
      modalTermino: false,
      guardarLoading: false,
      modalidades: [
        { id: 1, text: 'Interno' },
        { id: 2, text: 'Externo' }
      ],
      generos: {
        'F': 'Femenino',
        'M': 'Masculino'
      },
      solicitud: {
        dependencia: '',
        domicilioDependencia: '',
        ciudad: '',
        estado: '',
        titular: '',
        puesto: '',
        programa: '',
        tipoPrograma: '',
        responsable: '',
        modalidad: '',
        fechaInicio: null,
        fechaTermino: null,
        actividades: '',
        capturado: false,
        departamento: null
      },
      departamentos: []
    }),
    computed: {
      ...mapState({
        alumno: state => state.user.profile,
        creditosSuficientes: state => {
          const avance = (state.user.profile.creditosAprobados * 100) / state.user.profile.creditosCarrera
          return avance >= 70
        }
      }),
      enFecha () {
        const today = moment()
        const aperturaEneroJunio = moment()
        aperturaEneroJunio.set({'year': 2024, 'month': 0, 'date': 9, 'hour': 0, 'minute': 0, 'second': 0})
        const cierreEneroJunio = moment()
        cierreEneroJunio.set({'year': 2024, 'month': 1, 'date': 9, 'hour': 23, 'minute': 59, 'second': 59})
        const aperturaAgostoDiciembre = moment()
        aperturaAgostoDiciembre.set({'year': 2023, 'month': 1, 'date': 9, 'hour': 0, 'minute': 0, 'second': 0})
        const cierreAgostoDiciembre = moment()
        cierreAgostoDiciembre.set({'year': 2023, 'month': 2, 'date': 9, 'hour': 23, 'minute': 59, 'second': 59})
        console.log(aperturaAgostoDiciembre)
        console.log(cierreAgostoDiciembre)

        return today.isBetween(aperturaEneroJunio, cierreEneroJunio) || today.isBetween(aperturaAgostoDiciembre, cierreAgostoDiciembre)
      }
    },
    methods: {
      guardar () {
        console.log(this.valid)
        // if (!this.$refs.form.validate()) {
        //   return false
        // }
        axios.put('alumno/solicitud-servicio-social', this.solicitud)
          .then(response => {
            console.log(response)
            this.solicitud.capturado = true
          })
          .catch(error => {
            console.log(error)
          })
      },
      cargarDatos () {
        this.cargandoDatos = true
        axios.get('alumno/solicitud-servicio-social')
          .then(response => {
            this.cargandoDatos = false
            this.solicitud = response.data
            this.departamentos = [
              {clave: 'Ninguno', descripcion: 'Ninguno'},
              ...response.data.departamentos
            ]
            console.log('departamentos', this.departamentos)
            delete this.solicitud.departamentos
          })
      }
    },
    mounted () {
      if (this.creditosSuficientes) {
        this.cargarDatos()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/information/ServicioSocialPage.vue